import { render, staticRenderFns } from "./PannelFive.vue?vue&type=template&id=14c796e0&scoped=true&"
import script from "./PannelFive.vue?vue&type=script&lang=js&"
export * from "./PannelFive.vue?vue&type=script&lang=js&"
import style0 from "./PannelFive.vue?vue&type=style&index=0&id=14c796e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c796e0",
  null
  
)

export default component.exports